import { useQuery } from '@apollo/react-hooks';

import { SYLLABUS_MODE } from 'Domains/syllabus';
import { getIndividualUnitReport, getTKIndividualUnitReport } from 'GraphQL/queries/report.query';

const IndividualUnitReportData = ({ value, schoolCode, username, children }) => {
  const { term, grade, classNo, subject, syllabus, mode } = value;

  const variables = {
    schoolTermId: term,
    schoolGradeId: grade,
    classNo,
    subjectId: subject,
    courseCode: syllabus,
    classroomUsername: username,
    schoolCode,
  };

  const isSkip = !term || !grade || !classNo || !subject || !syllabus || !schoolCode || !username;

  const traditionalReport = useQuery(getIndividualUnitReport, {
    variables: variables,
    skip: isSkip || mode === SYLLABUS_MODE.TUNGKAI,
  });

  const tungkaiReport = useQuery(getTKIndividualUnitReport, {
    variables: variables,
    skip: isSkip || mode === SYLLABUS_MODE.TRADITIONAL,
  });

  const report = mode === SYLLABUS_MODE.TRADITIONAL ? traditionalReport : tungkaiReport;

  const { loading, error, data, refetch } = report;

  return children({ loading, error, data, refetch });
};

export default IndividualUnitReportData;
